import ProductList from './views/index.c';
export default ProductList;
